<section class="row p-2 pt-1" *ngIf="setting.options.length > 1">
  <mat-form-field *ngIf="showDragDropSection()" class="col-md-auto col-xs-12">
    <input
      matInput
      placeholder="Search"
      [(ngModel)]="searchText"
      (ngModelChange)="filterList()"
      (keydown.enter)="selectOption()"
      [acsFocus]="jumpFocus === 'searchText'"
    />
    <button mat-icon-button matSuffix (click)="clearInput()" color="warn">
      <mat-icon class="fa fa-close"></mat-icon>
    </button>
  </mat-form-field>

  <span class="align-self-center col col-xs-12">
    <button mat-raised-button class="md-button m-2" (click)="setting.selectAll()">All</button>
    <button mat-raised-button class="md-button m-2" *ngIf="setting.showNone" (click)="setting.unselectAll()">None</button>
    <span *ngFor="let group of setting.optionGroupings; trackBy: getIdentifierForIterableItem">
      <button
        mat-raised-button
        class="md-button m-2"
        aria-label=""
        *ngFor="let option of group.options; trackBy: getIdentifierForIterableItem"
        (click)="setting.selectGroup(group.id, option.id)"
      >
        {{ option.name }}
      </button>
    </span>
  </span>
</section>

<mat-list role="list" class="d-flex row" *ngIf="!showDragDropSection()">
  <mat-list-item
    class="col-4"
    role="listitem"
    *ngFor="let option of setting.options; trackBy: getIdentifierForIterableItem"
  >
    <mat-checkbox color="primary" [(ngModel)]="option.selected"
      ><p>{{ option.name }}</p></mat-checkbox
    >
  </mat-list-item>
</mat-list>

<div *ngIf="showDragDropSection()" class="row mb-3">
    <div class="example-container col">
      <h4 class="sub-header">Available</h4>

      <div
        cdkDropList
        #availableList="cdkDropList"
        [cdkDropListData]="available"
        [cdkDropListConnectedTo]="[selectedList]"
        class="example-list"
        style="max-height: 400px; overflow: auto;"
        (cdkDropListDropped)="drop($event)"
      >
        <div
          class="example-box"
          *ngFor="let item of available; trackBy: getIdentifierForIterableItem"
          cdkDrag
          [cdkDragDisabled]="selected.length === 12"
        >
          <mat-checkbox
            [(ngModel)]="item.selected"
            [disabled]="selected.length === 12"
            (ngModelChange)="filterList()"
            color="primary"
            >{{ item.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>

    <div class="example-container col">
      <h4 class="sub-header">Selected</h4>

      <div
        cdkDropList
        #selectedList="cdkDropList"
        [cdkDropListData]="selected"
        [cdkDropListConnectedTo]="[availableList]"
        class="example-list"
        style="max-height: 400px; overflow: auto;"
        (cdkDropListDropped)="drop($event)"
      >
        <div
          class="example-box"
          *ngFor="let item of selected; trackBy: getIdentifierForIterableItem"
          cdkDrag
          [cdkDragDisabled]="selected.length === 1"
        >
          <mat-checkbox
            [(ngModel)]="item.selected"
            [disabled]="selected.length === 1"
            color="primary"
            (ngModelChange)="filterList()"
            >{{ item.name }}</mat-checkbox
          >
        </div>
      </div>
    </div>
</div>
